<script>
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import commonMixin from '@/plans/ZM_AI_COMPANION/mixin';
import { planTypes } from '@/common/constants';

export default createEditDeltaComponent({
  name: 'AiCompanionEditDelta',
  planType: planTypes.ZM_AI_COMPANION,
  mixin: commonMixin,
});
</script>

<style lang="scss">
.opc-zwb {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>

